var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      staticClass: "voice-assistant-modal",
      attrs: { title: "", visible: true },
      on: { cancel: _vm.closeModal },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c("div", { staticClass: "d-flex gap-5 title" }, [
                _c("img", { attrs: { src: "/static/img/copilot.png" } }),
                _vm._v(" "),
                _c("h2", [_vm._v("Bu Sayfada Sesli Asistanı Var")]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "voice-assistant-content" }, [
        _c("h2", [_vm._v("Merhaba! " + _vm._s(_vm.user.name) + " 👋")]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n            Bu sayfada size yardımcı olacak bir "),
          _c("strong", [_vm._v("Yapay Zeka Asistanı")]),
          _vm._v(
            " olduğunu biliyor muydun?.\n            Asistanı kullanmak için aşağıdaki yöntemleri deneyebilirsiniz:\n        "
          ),
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v('CTRL + "')]),
            _vm._v(
              " tuş kombinasyonuna basılı tutup konuşarak komut verebilirsiniz."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("\n                Sağ üst köşedeki "),
            _c("img", {
              attrs: {
                src: "/static/img/copilot.png",
                width: "40",
                height: "40",
              },
            }),
            _vm._v(
              " simgesine tıklayarak\n                asistanı başlatabilirsiniz.\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "manual-main-content" }, [
          _c("div", { staticClass: "voice-commands" }, [
            _c("h3", [_vm._v("Örnek Sesli Komutlar:")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v('"Benim ticketlarımı göster."')]),
              _vm._v(" "),
              _c("li", [
                _vm._v('"Bugünkü Zeynep\'in açık ticketlarını göster."'),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v('"Ekrandaki ticketları sil."')]),
              _vm._v(" "),
              _c("li", [_vm._v("\"Sonuncu ticket'ı Ali'ye ata.\"")]),
              _vm._v(" "),
              _c("li", [
                _vm._v('"Tüm ticketların durumunu yapıldı olarak değiştir."'),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  '"Ekrandaki ticketların durumları ...... olarak ayarla."'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v('"Ekrandaki ticketlara .... kullanıcısına ata."'),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v('"İlk ticket\'ı bana ata."')]),
              _vm._v(" "),
              _c("li", [_vm._v('"Geçen ayki instagram ticketlarını göster."')]),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: "https://static.supsis.live/common/image/ticket-copilot.gif",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "assistant-animation" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }